import { render } from "./BancaliUscitaTable.vue?vue&type=template&id=01fcfbec&scoped=true"
import script from "./BancaliUscitaTable.vue?vue&type=script&lang=js"
export * from "./BancaliUscitaTable.vue?vue&type=script&lang=js"

import "./BancaliUscitaTable.vue?vue&type=style&index=0&id=01fcfbec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fcfbec"]])

export default __exports__